import React, { useState } from 'react';
import {
  Grid,
  Table,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Checkbox
} from '@material-ui/core';
import { makeStyles, withStyles, createStyles } from '@material-ui/core/styles';
import { List } from './List';
import type {
  TGuest,
  TGuestListSortParam
} from '../../types/cloudStorage/CloudFileList';
import SortButton from '../../components/SortButton';

type Tprops = {
  guestList: TGuest[];
  selectedGuestList: TGuest[];
  setSelectedGuestList: React.Dispatch<React.SetStateAction<TGuest[]>>;
  getSearchedGuestList: () => void;
  isFileMode: boolean;
  sortParams: TGuestListSortParam;
  setSortParams: any; //既存コード利用のためany
};

export const TableField: React.FC<Tprops> = (props: Tprops) => {
  const {
    guestList,
    selectedGuestList,
    setSelectedGuestList,
    getSearchedGuestList,
    isFileMode,
    sortParams,
    setSortParams
  } = props;

  const classes = useStyles();

  const [AllChecked, setAllChecked] = useState<boolean>(false);
  const [sortButtonName, setSortButtonName] = useState('');

  /**
   * 選択された共有先を追加
   * @param guest
   */
  const addSelectedGuest = (guest: TGuest) => {
    if (!selectedGuestList.includes(guest)) {
      setSelectedGuestList([...selectedGuestList, guest]);
    }
  };

  /**
   * 選択された共有先を追加(全件)
   */
  const addAllSelectedGuests = () => {
    setSelectedGuestList([]);
    setSelectedGuestList(guestList);
  };

  /**
   * 選択された共有先を削除
   * @param guest
   */
  const removeSelectedGuest = (guest: TGuest) => {
    if (selectedGuestList.includes(guest)) {
      const newSelectedFileIds = selectedGuestList.filter(
        f => f.id !== guest.id
      );
      setSelectedGuestList(newSelectedFileIds);
    }
  };

  /**
   * 選択された共有先を削除(全件)
   */
  const removeAllSelectedGuests = () => {
    setSelectedGuestList([]);
  };

  /**
   * 全件チェック
   */
  const handleAllCheck = (event: React.ChangeEvent<HTMLInputElement>) => {
    const checked: boolean = event.target.checked;
    if (checked) {
      addAllSelectedGuests();
    } else {
      removeAllSelectedGuests();
    }
    setAllChecked(checked);
  };

  /**
   * ソート項目
   */
  const changeSortParams = (params: any) => {
    setSortParams(params);
  };

  return (
    <>
      <Grid container>
        <Grid
          item
          xs={12}
          style={{
            backgroundColor: '#FFFFFF',
            borderBottom: '1px solid #f5f5f5',
            padding: '20px'
          }}
        >
          {guestList.length === 0 ? (
            <div>共有先がありません</div>
          ) : (
            <TableContainer component={Paper}>
              <Table className={classes.main} aria-label='customized table'>
                <TableHead>
                  <TableRow>
                    <StyledTableCell className={classes.table} align='center'>
                      <Checkbox
                        checked={AllChecked}
                        onChange={handleAllCheck}
                        color='default'
                      />
                    </StyledTableCell>
                    <StyledTableCell className={classes.table} align='center'>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        <div>工事案件名</div>

                        <SortButton
                          buttonName='construct_name'
                          getListData={getSearchedGuestList}
                          sortButtonName={sortButtonName}
                          setSortButtonName={setSortButtonName}
                          changeSortParams={changeSortParams}
                        />
                      </div>
                    </StyledTableCell>
                    <StyledTableCell className={classes.table} align='center'>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        <div>共有先</div>

                        <SortButton
                          buttonName='name'
                          getListData={getSearchedGuestList}
                          sortButtonName={sortButtonName}
                          setSortButtonName={setSortButtonName}
                          changeSortParams={changeSortParams}
                        />
                      </div>
                    </StyledTableCell>
                    <StyledTableCell className={classes.table} align='center'>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        <div>メールアドレス</div>

                        <SortButton
                          buttonName='email'
                          getListData={getSearchedGuestList}
                          sortButtonName={sortButtonName}
                          setSortButtonName={setSortButtonName}
                          changeSortParams={changeSortParams}
                        />
                      </div>
                    </StyledTableCell>
                    <StyledTableCell className={classes.table} align='center'>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        <div>共有期限</div>

                        <SortButton
                          buttonName='expiration_at'
                          getListData={getSearchedGuestList}
                          sortButtonName={sortButtonName}
                          setSortButtonName={setSortButtonName}
                          changeSortParams={changeSortParams}
                        />
                      </div>
                    </StyledTableCell>
                    <StyledTableCell className={classes.table} align='center'>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        <div>共有フォルダ</div>

                        <SortButton
                          buttonName='folder_name'
                          getListData={getSearchedGuestList}
                          sortButtonName={sortButtonName}
                          setSortButtonName={setSortButtonName}
                          changeSortParams={changeSortParams}
                        />
                      </div>
                    </StyledTableCell>
                    <StyledTableCell className={classes.table} align='center'>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        <div>最終アクセス</div>

                        <SortButton
                          buttonName='last_logged_in_at'
                          getListData={getSearchedGuestList}
                          sortButtonName={sortButtonName}
                          setSortButtonName={setSortButtonName}
                          changeSortParams={changeSortParams}
                        />
                      </div>
                    </StyledTableCell>
                    <StyledTableCell className={classes.table} align='center'>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        <div>共有者</div>

                        <SortButton
                          buttonName='created_name'
                          getListData={getSearchedGuestList}
                          sortButtonName={sortButtonName}
                          setSortButtonName={setSortButtonName}
                          changeSortParams={changeSortParams}
                        />
                      </div>
                    </StyledTableCell>
                    <StyledTableCell className={classes.table} align='center'>
                      <div
                        style={{
                          display: 'flex',
                          alignItems: 'center',
                          justifyContent: 'center'
                        }}
                      >
                        <div>共有日</div>

                        <SortButton
                          buttonName='created_at'
                          getListData={getSearchedGuestList}
                          sortButtonName={sortButtonName}
                          setSortButtonName={setSortButtonName}
                          changeSortParams={changeSortParams}
                        />
                      </div>
                    </StyledTableCell>
                    <StyledTableCell
                      className={classes.table}
                      align='center'
                    ></StyledTableCell>
                    <StyledTableCell
                      className={classes.table}
                      align='center'
                    ></StyledTableCell>
                  </TableRow>
                </TableHead>
                {guestList.map(guest => (
                  <List
                    key={guest.id}
                    guest={guest}
                    selectedGuestList={selectedGuestList}
                    getSearchedGuestList={getSearchedGuestList}
                    addSelectedGuest={() => addSelectedGuest(guest)}
                    removeSelectedGuest={() => removeSelectedGuest(guest)}
                    isFileMode={isFileMode}
                  />
                ))}
              </Table>
            </TableContainer>
          )}
        </Grid>
      </Grid>
    </>
  );
};

const useStyles = makeStyles(() =>
  createStyles({
    formControl: {
      minWidth: 120,
      backgroundColor: '#FFFFFF'
    },
    formControl1: {
      minWidth: 120,
      height: 30,
      borderRadius: 5,
      borderWidth: 1,
      paddingLeft: 5
    },
    main: {
      minWidth: 700
    },
    table: {
      backgroundColor: `#0099CC !important`,
      color: '#FFFFFF',
      padding: 10,
      fontWeight: 'bold',
      fontSize: 16
    },
    input: {
      borderColor: '#CCCCCC',
      padding: 5,
      margin: 10
    },
    table1: {
      padding: 8
    },
    container: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 15
    },
    modal: {
      // モーダルを中央に
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center'
    },
    popoverButton: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      cursor: 'pointer',
      borderBottom: '1px solid rgb(245, 245, 245)',
      padding: '20px 40px'
    }
  })
);

// スタイル関係
const StyledTableCell = withStyles(theme => ({
  head: {
    backgroundColor: theme.palette.common.black,
    color: theme.palette.common.white
  },
  body: {
    fontSize: 16
  }
}))(TableCell);
